import { Copy, Form, Heading } from './ModalContent.styles';
import SubmitButton from './SubmitButton';
import ZipInput from './ZipInput';

type OwnProps = {
  inputProps: any;
  onSubmit: (e: React.FormEvent<HTMLFormElement>) => void;
};

export default function GeolocationForm({ inputProps, onSubmit }: OwnProps) {
  return (
    <div className="flex flex-col gap-2xl">
      <div className="flex flex-col gap-lg">
        <Heading>Change your location</Heading>
        <Copy>
          Enter your ZIP code to see local delivery options and shipping costs.
        </Copy>
      </div>

      <Form data-testid="zipcode-form" onSubmit={onSubmit}>
        <ZipInput {...inputProps} />
        <SubmitButton />
      </Form>
    </div>
  );
}
